import Input from "../formik/input";
import InputPassword from "../formik/input-password";
import InputRadio from "../formik/input-radio";
import InputUpload from "../formik/input-upload";
import InputGroup from "../formik/input-group";
import InputMask from "../formik/input-mask";
import InputArray from "../formik/input-array";
import InputCheck from "../formik/input-check";
import InputSwitch from "../formik/input-switch";
import InputPhone from "../formik/input-phone";
import MultipleInput from "../formik/multiple-input";
import Textarea from "../formik/textarea";
import Button from "../formik/button";
import Link from "../formik/link";
import Title from "../formik/title";
import Select from "../formik/select";
import SelectChecklist from "../formik/select-checklist";
import Warning from "../formik/warning";
import Textline from "../formik/textLine";
import Multiselect from "../formik/multiselect";
import Subtitle from "../formik/subtitle";
import MultipleTextInput from "../formik/multiple-text-input";
import ActivitiesList from "../formik/activities-list";

export interface IComponentList {
  Input: any;
  InputMask: any;
  Select: any;
  Multiselect: any;
  Textarea: any;
  Button: any;
  Title: any;
  InputGroup: any;
  MultipleTextInput: any;
  InputCheck: any;
  Subtitle: any;
  Textline: any;
  InputRadio: any;
  InputUpload: any;
  InputPassword: any;
  InputArray: any;
  InputSwitch: any;
  InputPhone: any;
  Warning: any;
  SelectChecklist: any;
  MultipleInput: any;
  Link: any;
  ActivitiesList: any;
}

const ComponentsList: IComponentList = {
  Title,
  Subtitle,
  Textline,
  Input,
  InputRadio,
  InputUpload,
  InputPassword,
  InputGroup,
  InputMask,
  InputCheck,
  InputSwitch,
  Select,
  Textarea,
  Button,
  Link,
  InputArray,
  MultipleInput,
  Multiselect,
  SelectChecklist,
  InputPhone,
  Warning,
  MultipleTextInput,
  ActivitiesList,
};

export default ComponentsList;
